export const socialLinks = {
    facebook: 'https://www.facebook.com/HawkinsCarpetCleaningOwensboro/',
    instagram: 'https://www.instagram.com/hawkins_carpet_cleaning/',
    youtube: 'https://www.youtube.com/@hawkinscarpetcleaning5621',
    tiktok: 'https://www.tiktok.com/@hawkinscarpetcleaning'
}; 